<template>
  <div class="card shadow search-card">
    <div class="row g-0 h-100">
      <div class="col-3 d-flex align-items-center justify-content-center">
        <div class="p-3">
          <img
            class="img-fluid"
            v-if="offer.provider_image"
            :alt="offer.provider_image_description"
            :src="`${offer.provider_image_url}`"
          >
          <img
            v-else
            width="50"
            aria-hidden="true"
            :src="categoryIconFor(offer.category_id)"
          >
        </div>
      </div>

      <div class="col-9">
        <div class="card-body d-flex flex-column h-100">
          <div>
            <span v-if="isNewOffer" class="badge bg-light text-dark text-uppercase me-2 mb-2">New</span>
            <span v-if="offer.expiring_offer" class="badge bg-light text-dark text-uppercase mb-2">Expiring soon</span>
            <p class="card-text mb-1">
              <small class="text-muted"> {{ offer.provider }} </small>
            </p>
            <h4 class="card-title">
              <a :href="'/offers/' + offer.id" class="stretched-link text-dark">
                <strong>{{ offer.amount }}</strong>
                {{ offer.headline }}
              </a>
            </h4>
          </div>
          <div v-if="(offer.addresses && offer.addresses.length > 0) || (offer.online && (!offer.addresses || offer.addresses.length === 0))" class="mt-auto pt-1">
            <div class="d-flex column-gap-3 flex-wrap">
              <span v-if="distanceDisplay.shouldShow" class="d-flex align-items-center small text-muted">
                <i class="bi bi-geo-alt me-1"></i>
                {{ distanceDisplay.text }}
              </span>
              <span v-for="type in serviceTypeIconsFiltered" :key="type.name" class="d-flex align-items-center small text-muted">
                <i :class="type.icon + ' me-1'"></i>
                {{ type.label }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { DistanceDisplay } from '../utils/distance_display.js';
import LocationMixin from '../../mixins/location_mixin.js';

export default {
  mixins: [LocationMixin],
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isNewOffer() {
      if (!this.offer.start_date) {
        return false;
      }
      
      const startDate = moment(this.offer.start_date);
      const thirtyDaysAgo = moment().subtract(30, 'days');
      
      return startDate.isAfter(thirtyDaysAgo);
    },
    distanceDisplay() {
      return new DistanceDisplay(this.offer, this.currentLocationData);
    },
    serviceTypeIcons() {
      // Check if this is a digital service (online with no addresses)
      const hasAddresses = this.offer.addresses && Array.isArray(this.offer.addresses) && this.offer.addresses.length > 0;
      
      if (!hasAddresses && this.offer.online) {
        // Digital service - online only with no physical addresses
        return [{ name: 'digital', icon: 'bi bi-globe', label: 'Digital service' }];
      }
      
      if (!hasAddresses) {
        return [];
      }
      
      const addressTypes = [...new Set(this.offer.addresses.map(addr => addr.type))];
      
      const iconMap = {
        'physical': { name: 'physical', icon: 'bi bi-geo-alt', label: 'In-store' },
        'we_come_to_you': { name: 'we_come_to_you', icon: 'bi bi-truck', label: 'Service travels to you' },
        'delivery': { name: 'delivery', icon: 'bi bi-box-seam', label: 'Delivery' },
        'digital': { name: 'digital', icon: 'bi bi-globe', label: 'Digital service' }
      };
      
      const serviceTypes = addressTypes
        .map(type => iconMap[type])
        .filter(Boolean);
      
      return serviceTypes;
    },
    serviceTypeIconsFiltered() {
      const types = this.serviceTypeIcons;
      const locationData = this.currentLocationData;
      if (locationData?.lat && locationData?.lng) {
        return types.filter(type => type.name !== 'physical');
      }
      
      return types;
    },
  },
  methods: {
    categoryIconFor(category_id) {
      var categoryIcon = new URL(`../../images/icons/categories/${category_id}.svg`, import.meta.url).href;
      const urlParts = categoryIcon.split('/');
      if (urlParts[urlParts.length-1] == 'undefined') {
        categoryIcon =  new URL('../../images/icons/categories/no-logo-placeholder.svg', import.meta.url).href;
      }
      return categoryIcon;
    },
  },
};
</script>
